import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd045aService,
  Sgkd045aRequest,
  Sgkd045aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkd045aService {

  private _rsesult$ = new Subject<Sgkd045aResponse>();
  
  constructor(
    private sgkd045aService: Sgkd045aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 支払情報返却API呼び出し
   * 
   * @param firstSrvctrNo 契約お客さま番号
   * @memberof UsedSgkd002dSgkd045aService
   */
  doSgkd045a(firstSrvctrNo: string): Observable<Sgkd045aResponse> {

    // リクエスト生成
    let request: Sgkd045aRequest = {
      requestDto: {
        /** 契約お客さま番号 */
        firstSrvctrNo: firstSrvctrNo
      }
    };

    return this.sgkd045aService.doSGKD045APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
        // エラーが設定されていないかチェックする  
        this.apiCommonService.checkError(response);
        
        const body = this.trimObject(response.body);
        this._rsesult$.next(body);
        return body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD045A');
          return throwError(err.message);
        })
      )  
    }

  /**
   * trim処理
   * 
   * @param firstSrvctrNo 契約お客さま番号
   * @memberof UsedSgkd002dSgkd045aService
   */
  private trimObject(obj: any): any {

    if (obj === null || obj === undefined) {
      return obj;
    }
    
    if (typeof obj === 'string') {
      return obj.trim();
    }

    if (Array.isArray(obj)) {
      return obj.map(x => this.trimObject(x));
    }
    if (typeof obj === 'object') {
      Object.keys(obj).forEach(key => {
      obj[key] = this.trimObject(obj[key]);
    });
    return obj;
    }
    return obj;
    }
}
